<template>
  <div>
    <v-row v-if="loading">
      <v-col>
        <v-progress-circular indeterminate />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-card
          flat
          class="px-4 py-3"
          height="100%"
          :key="reRender"
          :class="!isEditCard1 ? 'mouse-cursor' : ''"
        >
          <div class="text-start">
            <v-row class="py-3">
              <v-col>
                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <!-- {{ key.charAt(0).toUpperCase() + key.slice(1) }} -->
                    <span>{{ $t("organization.about") }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                    :style="
                      isEditCard1
                        ? 'pointer-events: all'
                        : 'pointer-events: none'
                    "
                  >
                    <LocalisedContentEditable
                      :values="card1.description"
                      @update:values="
                        values => (this.card1.description = values)
                      "
                      :text-area-outlined="false"
                      :editable="true"
                      css-class="text-subtitle-1 font-weight-regular textLight--text"
                      :showLanguageTabs="false"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.email") }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.email"
                      :isEdit="isEditCard1"
                      :validateRules="'email'"
                      ref="email"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("organization.contactNo") }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.phone"
                      :isEdit="isEditCard1"
                      :validateRules="'numeric|max:10'"
                      ref="phone"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("organization.contactName") }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.contactName"
                      :isEdit="isEditCard1"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
          <float-btn
            v-if="!loading && havePermissionUpdateOrganization"
            :isEdit="isEditCard1"
            @save="saveCard1Items"
            @edit="isEditCard1 = true"
            :bottom="true"
            :align="'right'"
            :loading="savingData1"
          />
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbarError" timeout="3000" color="error">
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="
            snackbarError = false;
            snackbarErrorMessage = null;
          "
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Editable2 from "../../../core-module/components/ContentEditable2.vue";
import FloatBtn from "../../../user-module/components/employee-profile/FloatBtn.vue";
import LocalisedContentEditable from "@/app/core-module/components/LocalisedContentEditable";

import { createOrUpdateOrganization } from "../../methods/createOrUpdateOrganization";
import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  components: {
    Editable2,
    FloatBtn,
    LocalisedContentEditable,
  },
  props: {
    organizationData: {
      type: Object,
      default: () => {},
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      snackbarError: false,
      snackbarErrorMessage: null,
      card1: {
        description: "",
        email: "",
        phone: "",
        contactName: "",
      },
      card1Error: {
        email: null,
        phone: null,
      },
      organizationProfile: null,
      savingData1: false,

      isEditCard1: false,

      reRender: 0,
    };
  },
  computed: {
    havePermissionUpdateOrganization() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["UPDATE_ORGANIZATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },

  watch: {
    organizationData: {
      immediate: true,
      handler() {
        this.organizationProfile = this.organizationData
          ? this.organizationData
          : null;
        this.resetFormData();
      },
      deep: true,
    },
  },
  methods: {
    resetFormData() {
      this.card1.description = this.organizationProfile?.description;

      this.card1.email = this.organizationProfile?.email;
      this.card1.phone = this.organizationProfile?.phone;
      this.card1.contactName = this.organizationData?.contactName;

      this.reRender++;
    },
    resetCard1Error() {
      this.card1Error = {
        email: null,
        phone: null,
      };
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateServer(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },

    async saveCard1Items() {
      this.resetCard1Error();
      this.snackbarErrorMessage = null;

      this.card1Error.email = (await this.$refs.email.checkIsValid())
        ? null
        : true;

      this.card1Error.phone = (await this.$refs.phone.checkIsValid())
        ? null
        : true;

      if (Object.values(this.card1Error).some(x => x != null)) {
        return;
      }

      if (this.organizationProfile._id) {
        this.savingData1 = true;
        this.isEditCard1 = false;
        await createOrUpdateOrganization({
          _id: this.organizationProfile._id,
          description: this.filterEmptyLocalisedValues(this.card1.description),
          email: this.card1?.email ? this.card1.email : " ",
          phone: this.card1?.phone ? this.card1.phone : " ",
          contactName: this.card1?.contactName ? this.card1.contactName : " ",
        }).then(response => {
          this.savingData1 = false;
        });
      }
    },
  },
};
</script>
